module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Контент")]), _vm._v(" "), ((_vm.cmsContents != null)) ? _c('div', [_c('entity-manager', {
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "data": _vm.cmsContents,
      "options": _vm.cmsContentsEntityManagerOptions
    },
    scopedSlots: _vm._u([{
      key: "dataItemFieldTableView",
      fn: function(viewProps) {
        return [_c('span', [_vm._v("\n          " + _vm._s(viewProps.dataRow.val[viewProps.column.field]) + "\n        ")])]
      }
    }, {
      key: "dataItemFieldEditView",
      fn: function(viewProps) {
        return [((viewProps.fieldKey == 'name') || (viewProps.fieldKey == 'type') || (viewProps.fieldKey == 'url') || (viewProps.fieldKey == 'summary')) ? _c('span', [_c('Input', {
          staticStyle: {
            "width": "100%"
          },
          model: {
            value: (viewProps.editingDataRow.val[viewProps.fieldKey]),
            callback: function($$v) {
              var $$exp = viewProps.editingDataRow.val,
                $$idx = viewProps.fieldKey;
              if (!Array.isArray($$exp)) {
                viewProps.editingDataRow.val[viewProps.fieldKey] = $$v
              } else {
                $$exp.splice($$idx, 1, $$v)
              }
            },
            expression: "viewProps.editingDataRow.val[viewProps.fieldKey]"
          }
        })], 1) : ((viewProps.fieldKey == 'body') || (viewProps.fieldKey == 'fields')) ? _c('span', [_c('Input', {
          attrs: {
            "type": "textarea",
            "rows": 10
          },
          model: {
            value: (viewProps.editingDataRow.val[viewProps.fieldKey]),
            callback: function($$v) {
              var $$exp = viewProps.editingDataRow.val,
                $$idx = viewProps.fieldKey;
              if (!Array.isArray($$exp)) {
                viewProps.editingDataRow.val[viewProps.fieldKey] = $$v
              } else {
                $$exp.splice($$idx, 1, $$v)
              }
            },
            expression: "viewProps.editingDataRow.val[viewProps.fieldKey]"
          }
        }), _vm._v(" "), _c('vue-html5-editor', {
          attrs: {
            "content": viewProps.editingDataRow.val[viewProps.fieldKey],
            "height2": "350"
          },
          on: {
            "change": function(val) {
              viewProps.editingDataRow.val[viewProps.fieldKey] = val
            }
          }
        })], 1) : _c('span', {
          staticStyle: {
            "width": "100%",
            "height": "26px"
          }
        }, [_vm._v("\n          " + _vm._s(viewProps.editingDataRow.val[viewProps.fieldKey]) + "\n        ")])]
      }
    }])
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3641be99","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CMSX/Content.vue
// module id = 372
// module chunks = 0